import React from "react";
import { CustomLottie } from "../../CustomLottie";
export const CardWithImageAndTitleAnimated = ({ cardTitle, cardSubTitle, cardAnimation, cardColor, cardFontSize }) => (React.createElement("div", { className: "card-with-image-and-title-animated", style: { backgroundColor: cardColor } },
    React.createElement(CustomLottie, { animation: cardAnimation }),
    React.createElement("div", { className: "card-with-image-and-title-animated__textWrapper" },
        React.createElement("h5", { className: "card-title", style: { "--card-font-size": cardFontSize } }, cardTitle),
        React.createElement("p", { className: "card-subtitle" }, cardSubTitle))));
